import { config } from 'data';
import { profileService } from 'services';
import { useQuery } from 'hooks';

const useProfileBalanceQuery = () => useQuery({
  queryKey: [config.PROFILE_BALANCE_QUERY_KEY],
  queryFn: () => profileService.getBalance(),
});

export default useProfileBalanceQuery;
